module.exports = __webpack_public_path__ + "img/Chart_M@2x.6b489ed3.png";